/* Odorato · Q4 · Test de aroma (UI-UX P2 #32, 19-oct). Sección q4-test-aroma.
   - Tres preguntas. Con el mouse o el dedo pasa sola a la siguiente; con el teclado se elige y se confirma con Enter.
   - Puntaje de cada decant de la colección: 3 por cada nota que calza con el aroma elegido, 2 si el género calza
     (1 si es unisex; el género opuesto queda fuera), 2 si el momento calza y hasta 2 por ventas (el orden de la
     colección). Solo cuentan los que tienen al menos una nota del aroma; máximo uno por marca.
   - «Agregar los 3» usa el carrito Q4 (q4-carrito.js) y lo abre; sin él, va a /cart. */
(() => {
  const RAIZ = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  const plata = (c) => '$' + Math.round(c / 100).toLocaleString('es-CL');
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const partir = (t) => String(t || '').split(/\s*[,|\n]\s*/).map((x) => x.trim()).filter(Boolean);

  class Test {
    constructor(el) {
      this.el = el;
      this.form = el.querySelector('[data-q4-test-form]');
      this.pasos = Array.from(el.querySelectorAll('[data-q4-test-p]'));
      this.res = el.querySelector('[data-q4-test-resultado]');
      this.atras = el.querySelector('[data-q4-test-atras]');
      this.i = 0;
      this.puntero = 0;
      try {
        this.datos = JSON.parse(el.querySelector('[data-q4-test-datos]').textContent).map((d, r) => ({
          h: d[0], n: d[1], m: d[2], u: d[3], f: d[4], g: d[5], notas: partir(d[6]), mom: partir(d[7]), r,
          v: (d[8] || []).filter((x) => x[4]).map((x) => ({ id: x[0], t: x[1], p: x[2], c: x[3] }))
        })).filter((d) => d.v.length);
      } catch (e) { this.datos = []; }

      el.addEventListener('pointerdown', (e) => { if (e.target.closest('.q4-test__op')) this.puntero = Date.now(); });
      this.form.addEventListener('change', (e) => {
        if (e.target.type !== 'radio') return;
        // con el mouse o el dedo avanza sola; con las flechas del teclado solo marca (Enter confirma)
        if (Date.now() - this.puntero < 1500) setTimeout(() => this.siguiente(), 220);
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.siguiente(); });
      this.form.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && e.target.type === 'radio') { e.preventDefault(); this.siguiente(); }
      });
      this.atras.addEventListener('click', () => this.ir(this.i - 1, true));
      el.querySelector('[data-q4-test-reiniciar]').addEventListener('click', () => this.reiniciar());
      el.querySelector('[data-q4-test-agregar]').addEventListener('click', () => this.agregar());
      this.res.addEventListener('change', (e) => { if (e.target.matches('[data-q4-test-talla]')) this.precios(); });
    }

    valor(nombre) { const x = this.form.querySelector('input[name="' + nombre + '"]:checked'); return x || null; }

    ir(i, foco) {
      this.i = Math.max(0, Math.min(this.pasos.length - 1, i));
      this.pasos.forEach((p, k) => { p.hidden = k !== this.i; });
      this.res.hidden = true;
      this.form.hidden = false;
      this.atras.hidden = this.i === 0;
      const total = this.pasos.length;
      const barra = this.el.querySelector('[data-q4-test-barra]');
      if (barra) barra.style.width = ((this.i + 1) / total) * 100 + '%';
      const paso = this.el.querySelector('[data-q4-test-paso]');
      if (paso) paso.textContent = (this.el.dataset.paso || '').replace('[n]', this.i + 1).replace('[total]', total);
      this.el.querySelector('[data-q4-test-avance]').hidden = false;
      if (foco) {
        const l = this.pasos[this.i].querySelector('legend');
        if (l) l.focus({ preventScroll: true });
        this.alInicio();
      }
    }

    // Lleva el recuadro arriba si quedó fuera de la vista. scrollIntoView sirve aunque desde 990 px la página se
    // deslice dentro de .page-wrapper y no en la ventana
    alInicio() {
      const marco = this.el.querySelector('.q4-test__marco') || this.el;
      const r = marco.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.45) {
        const cab = document.querySelector('#header-group, header-component, .header');
        const alto = cab ? Math.min(cab.getBoundingClientRect().height, 140) : 0;
        marco.style.scrollMarginTop = alto + 12 + 'px';
        marco.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }

    siguiente() {
      const actual = this.pasos[this.i];
      if (!actual.querySelector('input:checked')) return;
      if (this.i < this.pasos.length - 1) this.ir(this.i + 1, true);
      else this.resultado();
    }

    reiniciar() {
      this.form.reset();
      this.ir(0, true);
    }

    elegir() {
      const gen = this.valor('genero');
      const g = gen ? gen.value : '';
      const ar = this.valor('aroma');
      const notas = new Set(partir(ar && ar.dataset.notas).map(norm));
      const mo = this.valor('momento');
      const momentos = new Set(partir(mo && mo.value).map(norm));
      const N = Math.max(1, this.datos.length);
      const lista = this.datos.map((p) => {
        if (g && p.g && p.g !== g && p.g !== 'Unisex') return null;
        const calza = p.notas.filter((n) => notas.has(norm(n)));
        if (!calza.length) return null;
        let s = calza.length * 3;
        if (g) s += p.g === g ? 2 : 1;
        const enMomento = momentos.size > 0 && p.mom.some((m) => momentos.has(norm(m)));
        if (enMomento) s += 2;
        s += 2 * (1 - p.r / N);
        return { p, s, calza };
      }).filter(Boolean).sort((a, b) => b.s - a.s);
      const marcas = new Set();
      const elegidos = [];
      for (const x of lista) {
        const k = norm(x.p.m);
        if (marcas.has(k)) continue;
        marcas.add(k);
        elegidos.push(x);
        if (elegidos.length === 3) break;
      }
      return elegidos;
    }

    tarjeta(x, k) {
      const p = x.p;
      const quiero = norm(this.el.dataset.tam || '2 ml');
      const def = p.v.find((v) => norm(v.t) === quiero) || p.v[0];
      const id = 'q4-test-t' + k;
      const opciones = p.v.map((v) => '<option value="' + v.id + '" data-p="' + v.p + '" data-c="' + v.c + '"' + (v === def ? ' selected' : '') + '>' + esc(v.t) + '</option>').join('');
      return '<li class="q4-test__item">' +
        '<a class="q4-test__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
          (p.f ? '<img src="' + esc(p.f) + '" alt="" loading="lazy" width="400" height="400">' : '') + '</a>' +
        '<div class="q4-test__info">' +
          '<p class="q4-test__marca">' + esc(p.m) + '</p>' +
          '<a class="q4-test__nombre" href="' + esc(p.u) + '">' + esc(p.n) + '</a>' +
          '<p class="q4-test__por">' + x.calza.slice(0, 3).map(esc).join(' · ') + '</p>' +
          '<div class="q4-test__fila">' +
            '<label class="visually-hidden" for="' + id + '">Tamaño de ' + esc(p.n) + '</label>' +
            '<select class="q4-test__talla" id="' + id + '" data-q4-test-talla>' + opciones + '</select>' +
            '<p class="q4-test__precio" data-q4-test-precio></p>' +
          '</div>' +
        '</div>' +
      '</li>';
    }

    precios() {
      let total = 0;
      this.res.querySelectorAll('.q4-test__item').forEach((li) => {
        const o = li.querySelector('[data-q4-test-talla]').selectedOptions[0];
        const p = parseInt(o.dataset.p, 10) || 0, c = parseInt(o.dataset.c, 10) || 0;
        total += p;
        const pct = c > p ? Math.floor((c - p) * 100 / c) : 0;
        li.querySelector('[data-q4-test-precio]').innerHTML = '<span>' + plata(p) + '</span>' + (pct > 0 ? ' <span class="q4-test__sello">−' + pct + '&nbsp;%</span>' : '');
      });
      const b = this.el.querySelector('[data-q4-test-agregar]');
      const n = this.res.querySelectorAll('.q4-test__item').length;
      b.textContent = (this.el.dataset.boton || '').replace('[total]', plata(total)).replace('los 3', n === 3 ? 'los 3' : 'los ' + n);
    }

    resultado() {
      const elegidos = this.elegir();
      const ar = this.valor('aroma');
      const mo = this.valor('momento');
      const aroma = (ar && ar.dataset.nombre) || '';
      const momento = (mo && mo.dataset.nombre) || '';
      const res = this.el.querySelector('[data-q4-test-resumen]');
      res.textContent = (res.dataset.plantilla || '').replace('[aroma]', aroma).replace(momento ? '[momento]' : / ?\[momento\]/, momento);
      const mas = this.el.querySelector('[data-q4-test-mas]');
      const col = ar && ar.dataset.coleccion;
      mas.hidden = !col;
      if (col) { mas.href = col; mas.textContent = (mas.dataset.plantilla || '').replace('[aroma]', aroma); }
      this.res.querySelector('[data-q4-test-lista]').innerHTML = elegidos.map((x, k) => this.tarjeta(x, k)).join('');
      this.el.querySelector('[data-q4-test-error]').hidden = true;
      const b = this.el.querySelector('[data-q4-test-agregar]');
      b.disabled = !elegidos.length;
      this.precios();
      this.form.hidden = true;
      this.el.querySelector('[data-q4-test-avance]').hidden = true;
      this.res.hidden = false;
      const t = this.el.querySelector('[data-q4-test-r-titulo]');
      if (t) t.focus({ preventScroll: true });
      this.alInicio();
    }

    async agregar() {
      const b = this.el.querySelector('[data-q4-test-agregar]');
      const err = this.el.querySelector('[data-q4-test-error]');
      const items = Array.from(this.res.querySelectorAll('[data-q4-test-talla]')).map((s) => ({ id: parseInt(s.value, 10), quantity: 1 }));
      if (!items.length) return;
      const texto = b.textContent;
      b.disabled = true;
      b.textContent = this.el.dataset.botonCargando || texto;
      err.hidden = true;
      const nodo = document.querySelector('[data-q4c]');
      const carrito = nodo && nodo._q4c;
      let ok = false;
      try {
        if (carrito) {
          ok = await carrito.encolar(() => carrito.agregar(items));
          if (ok) carrito.abrir();
        } else {
          const r = await fetch(RAIZ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          ok = r.ok;
          if (ok) { window.location.href = RAIZ + 'cart'; return; }
        }
      } catch (e) { ok = false; }
      b.disabled = false;
      b.textContent = texto;
      if (!ok) err.hidden = false;
    }
  }

  const iniciar = () => document.querySelectorAll('[data-q4-test]').forEach((el) => { if (!el._q4t) el._q4t = new Test(el); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
